var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-container"},[_c('video',{attrs:{"poster":_setup.videoPoster,"controls":"","controlslist":"nodownload"}},[_c('source',{attrs:{"src":_setup.videoUrl,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }